module.exports = __webpack_public_path__ + "896330b72092b57179e09d43f831211b.svg";